let API_URL

if (process.env.NODE_ENV === 'production') {
  API_URL = '/api'
} else {
  API_URL = 'http://127.0.0.1:8000/api'
}

export { API_URL }
